
export enum AppButtonTypes {
   PRIMARY = "PRIMARY",
   SECONDARY = "SECONDARY",
   OUTLINED_PRIMARY = "OUTLINED_PRIMARY",
   OUTLINED_SECONDARY = "OUTLINED_SECONDARY",
}

export interface ButtonProps {
   buttonContent: string | React.ReactNode | React.ReactNode[];
   onClick?: Function;
   className?: string,
   uiButtonType?: keyof typeof AppButtonTypes;
   disabled?: boolean,
   isLoading?: boolean;

   [key: string]: any;
}